import React, { useEffect } from "react";
import HeaderTitle from "../../../../common/HeaderTitle";
const AssesmentTab = (props) => {



  useEffect(() => {
    if (props?.viewDataFromSupplier?.IsSelfAssessmentSubmittedByRequester) {
      props?.setShowContentForm(true);
      props?.setShowAssessment(true)
    }
  }, [props?.setShowAssessment]);

  return (
    <>
      <div className="assesment-tab-wrap hl-tabs-container">
        <div className="capabilty-content mb-5">
          <HeaderTitle
            title={
              <>
                Please assess supplier capabilities in the following key areas and score yourself on a scale of 0 to 4
                <span className="text-sm block mt-1">
                  ( <span className="pr-3 mr-2">0 = Inadequate,</span>
                  <span className="pr-3 mr-2">1 = Below,</span>
                  <span className="pr-3 mr-2">2 = Average,</span>
                  <span className="pr-3 mr-2">3 = Good,</span>
                  <span>4 = Best Practice</span> )
                </span>
              </>
            }
            customClass="mt-4"
          />
          <ul className="pl-3 hl-list-style">
            <li>
              <i class="fa fa-angle-double-right" aria-hidden="true"></i>
              <span>Quality:</span>
              <p>Rate supplier quality control processes, adherence to quality standards, and overall product/service quality.</p>
            </li>
            <li>
              <i class="fa fa-angle-double-right" aria-hidden="true"></i>
              <span>Production Capacity:</span>
              <p>Evaluate supplier production capacity, including the volume and efficiency of production.</p>
            </li>
            <li>
              <i class="fa fa-angle-double-right" aria-hidden="true"></i>
              <span>Logistics:</span>
              <p>Assess supplier logistics capabilities, including material handling, and inventory management.</p>
            </li>
            <li>
              <i class="fa fa-angle-double-right" aria-hidden="true"></i>
              <span>Sustainability Management:</span>
              <p>Rate supplier sustainability initiatives, environmental practices, and commitment to sustainable business practices.</p>
            </li>
          </ul>
        </div>
      </div>
      <div className="text-right bluefooter-butn mt-4 hl-btm-footer sf-btn-footer sticky-btn-footer">
        <button
          type="submit"
          className="submit-button save-btn"
          onClick={() => {
            props?.setShowAssessment(true);
          }}
        >
          <div className="send-for-approval mr-1"></div>
          {"Requestor Assessment"}
        </button>
      </div>
    </>
  );
};

export default AssesmentTab;
